export const useMenuStore = defineStore('MenuStore', {
  state: () => {
    return {
      menuList: [
        {
          title: 'football_trips',
          route: 'pakker?sportCategories=soccer',
          routeName: 'packages',
          slug: null,
          query: { sportCategories: 'soccer' },
          submenu: []
        },
        {
          title: 'offer',
          route: 'pakker?hasOffer=true',
          routeName: 'packages',
          slug: null,
          query: { hasOffer: true },
          submenu: []
        },
        {
          title: 'leagues',
          routeName: 'packages',
          slug: null,
          route: '',
          submenu: []
        },
        {
          title: 'sport_categories',
          routeName: 'packages',
          slug: null,
          route: '',
          submenu: []
        },

        /* {
                // If the title is changed, the getSubmenuItems should be updated as well.
                title: 'Sportsrejser',
                route: 'packages',
                // We get the below sport categories from the API
                submenu: [
                  {
                    title: 'Fodboldrejser',
                    route: 'pakker?sportCategories=soccer',
                    isDisabled: false
                  },
                  {
                    title: 'Formel 1',
                    route: 'pakker?sportCategories=formula-1',
                    isDisabled: false
                  },
                  {
                    title: 'Rugby rejser',
                    route: 'pakker?sportCategories=rugby-union',
                    isDisabled: false
                  },
                  {
                    title: 'NFL rejser',
                    route: 'pakker?sportCategories=nfl',
                    isDisabled: false
                  },
                  {
                    title: 'Dart',
                    route: 'pakker?sportCategories=dart',
                    isDisabled: false
                  },
                  {
                    title: 'Hestevæddeløb',
                    route: 'pakker?sportCategories=horse-racing',
                    isDisabled: false
                  },
                  {
                    title: 'Tennis (kommer snart)\n',
                    route: 'pakker?sportCategories=tennis',
                    isDisabled: true
                  }

                ]
              }, */
        {
          title: 'gift_card',
          route: 'gift-card',
          routeName: 'gift-card',
          slug: null,
          query: {},
          submenu: []
        },
        {
          title: 'profession',
          route: 'info/profession',
          routeName: 'info-profession',
          slug: null,
          query: {},
          submenu: []
        },
        {
          title: 'about_us',
          route: 'info/om-os',
          routeName: 'info-slug',
          slug: 'om-os',
          query: {},
          submenu: []
        }
      ]
    }
  },
  actions: {
    build () {
      const sportCategories = useSportCategoryStore().categories
      const allTournaments = [...useTournamentStore().tournaments]
      const tournaments = allTournaments.slice(0, 20)

      const menuList = this.menuList.map(
        ({ title, route, routeName, slug, query, submenu }) => {
          if (title === 'leagues') {
            submenu = tournaments.map(tournament => ({
              title: tournament.name,
              route: `packages?tournaments=${tournament.slug}`,
              routeName: 'packages',
              slug: null,
              query: { tournaments: tournament.slug },
              isDisabled: false
            }))
          }
          if (title === 'sport_categories') {
            submenu = sportCategories
              .filter(sportCategory => sportCategory.isActive)
              .map(sportCategory => ({
                title: sportCategory.name,
                route: sportCategory.slug === 'soccer'
                  ? `pakker?sportCategories=${sportCategory.slug}`
                  : `https://sportspakker.dk/pakker?sportCategories=${sportCategory.slug}`,
                routeName: sportCategory.slug === 'soccer' ? 'packages' : 'external',
                slug: null,
                query: sportCategory.slug === 'soccer' ? { sportCategories: sportCategory.slug } : null,
                isDisabled: false,
                isExternal: sportCategory.slug !== 'soccer'
              }))
          }
          return {
            title,
            route,
            routeName,
            slug,
            query,
            submenu
          }
        }
      )

      this.menuList = menuList
    }
  }
})
